export default __webpack_public_path__ + "00a47a064d67f589470a54c4d6d1c100.png";